/**
 * @override
 * Override base fragment to include body.json but NOT links.
 * Links are fetched separately via useAccordionLinks hook with error handling.
 * This ensures content always renders even if embedded entries are unpublished.
 */

import gql from 'graphql-tag';

export const BaseAccordionFragment = gql`
  fragment BaseAccordionFragment on Accordion {
    __typename
    sys {
      id
    }
    title
    body {
      json
    }
    sortOrder
  }
`;
